import { useEffect } from 'react';

import {
  UseRbacRoleBindingsInfiniteQueryArgs,
  useRbacRoleBindingsInfiniteQuery,
} from './useRbacRoleBindingsInfiniteQuery';

export const useRbacRoleBindings = ({
  enabled,
  organizationId,
  subjectId,
  shouldTriggerRetry,
}: UseRbacRoleBindingsInfiniteQueryArgs = {}) => {
  const paginatedResponse = useRbacRoleBindingsInfiniteQuery({
    enabled,
    organizationId,
    subjectId,
    shouldTriggerRetry,
  });

  const { fetchNextPage, hasNextPage, isFetchingNextPage } = paginatedResponse;

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  return {
    isLoadingRoleBindings:
      paginatedResponse.isLoading || paginatedResponse.hasNextPage,
    isRoleBindingsError: paginatedResponse.isError,
    roleBindingsError: paginatedResponse.error,
    roleBindings: paginatedResponse.hasNextPage ? [] : paginatedResponse.data,
    refetchRoleBindings: paginatedResponse.refetch,
  };
};
